// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dataAuth-permissionObj {\n  display: flex;\n}\n.permission-dimension-select input {\n  background-color: #edeff0;\n  border: none;\n  font-size: 16px;\n}\n.permission-dimension-select .el-select__caret {\n  font-size: 16px !important;\n}\n.dataAuth-selectList {\n  display: flex;\n  flex: 2;\n}\n.dataAuth-config-table {\n  flex: 3;\n  /* width: calc(100% - 700px); */\n}\n.dataAuth-config-table-btn {\n  text-align: right;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
